export default __webpack_public_path__ + "static/media/grey-bullet.1811d2f6.svg";